import { memo } from "react";
import { Box } from "@mui/material";
import styles from "./styles";

const Loader = () => (
  <Box sx={styles.container} className="RlxLoader">
    <Box sx={styles.outer}>
      <Box sx={styles.inner} />
    </Box>
  </Box>
);

Loader.displayName = "Loader";

export default memo(Loader);
